import { IContractModel } from "@app/shared/shared.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const contractAdapter: EntityAdapter<IContractModel> = createEntityAdapter<IContractModel>({
	selectId: contract => contract.id
});